export enum SellDeliveryMethodActionTypes {
  SELECT_DELIVERY_METHOD = 'SELECT_DELIVERY_METHOD',
  RESET_TRANSACTION = 'RESET_TRANSACTION',
}
